import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createBankValidationSchema = Yup.object().shape({
  bankName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankNumber: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  ownerName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
